import {
    Button, Dialog, DialogContent, DialogTitle,
    Divider, Grid, IconButton, Typography
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { useState } from "react";
import { useLinkNewAssetSubmit, useRemoveLinkedAssets, useUpdateLinkedAssets } from "../stressEntry/stressEntryQueries";
import { useFetchContext } from "../../../common/FetchContext";
import { toast } from "react-toastify";

export const LinkAssetConfirmDialog = ({ open, onClose, payload, namepayload, mode, asset }: any) => {

    const { mutateAsync: mutateLinkNewAsset, isLoading: isLoadingAddDateApproved } = useLinkNewAssetSubmit();
    const { authAxios } = useFetchContext();

    const { mutateAsync: addAsset, isLoading: isAdding } = useLinkNewAssetSubmit();
    const { mutateAsync: editAsset, isLoading: isEditing } = useUpdateLinkedAssets();
    const { mutateAsync: removeAsset, isLoading: isRemoving } = useRemoveLinkedAssets();

    const handleSubmit = async () => {
        try {
            console.log("Submitting payload:", payload);

            if (mode === "add") {
                await addAsset({ authAxios, payload });
                toast.success("Asset Linked Successfully!");
            } else if (mode === "edit") {
                await editAsset({ authAxios, payload });
                toast.success("Linked Assets Updated Successfully!");
            } else if (mode === "remove") {
                await removeAsset({
                    authAxios,
                    payload: { asset_calibration_id: asset.id },
                });
                toast.success("Linked Assets Removed Successfully!");
            }

            onClose();
             window.location.reload();
            
        } catch (error: any) {
            console.error(error);

            if (mode === "add") {
                toast.error("Error while Linking Asset");
            } else if (mode === "edit") {
                toast.error("Error while Updating Linked Assets");
            } else if (mode === "remove") {
                toast.error("Error while Removing Linked Assets");
            }
        }
    };

    const isLoading = isAdding || isEditing || isRemoving;



    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Grid container alignItems="center" justifyContent="center">
                    <Grid item xs >
                        {mode === "add" && "Add New Asset Confirmation"}
                        {mode === "edit" && "Update Linked Assets Confirmation"}
                        {mode === "remove" && "Remove Linked Assets"}
                    </Grid>
                    <Grid item>
                        <IconButton onClick={onClose}><CloseIcon /></IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <Divider />

            <DialogContent dividers>
                <Grid container spacing={4} direction="column">

                    <Grid item style={{ marginLeft: 15 }}>
                        <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                            Asset Name
                        </Typography>

                        <Typography style={{ marginTop: "10px", marginLeft: "10px" }}>
                            {mode === "remove" || mode === "edit"
                                ? asset?.asset_name
                                : namepayload?.asset_calibration_name}
                        </Typography>
                    </Grid>

                    <Grid item style={{ marginLeft: 15 }}>
                        <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                            Linked Assets under{" "}
                            {mode === "remove"
                                ? asset?.asset_name
                                : namepayload?.asset_calibration_name}
                        </Typography>

                        {/* Sub-assets list based on mode */}
                        {mode === "remove" ? (
                            asset?.subassets?.length > 0 ? (
                                asset.subassets.map((linkedAsset: string, index: number) => (
                                    <Typography
                                        key={index}
                                        style={{
                                            color: "#000000DE",
                                            fontSize: "14px",
                                            marginTop: "10px",
                                            marginLeft: "10px",
                                        }}
                                    >
                                        {index + 1}. {linkedAsset}
                                    </Typography>
                                ))
                            ) : (
                                <Typography
                                    style={{
                                        color: "#000000DE",
                                        fontSize: "14px",
                                        marginTop: "10px",
                                    }}
                                >
                                    There are no assets linked to this asset.
                                </Typography>
                            )
                        ) : namepayload?.sub_asset_names?.length > 0 ? (
                            namepayload.sub_asset_names.map((linkedAsset: string, index: number) => (
                                <Typography
                                    key={index}
                                    style={{
                                        color: "#000000DE",
                                        fontSize: "14px",
                                        marginTop: "10px",
                                        marginLeft: "10px",
                                    }}
                                >
                                    {index + 1}. {linkedAsset}
                                </Typography>
                            ))
                        ) : (
                            <Typography
                                style={{
                                    color: "#000000DE",
                                    fontSize: "14px",
                                    marginTop: "10px",
                                }}
                            >
                                There are no assets linked to this asset.
                            </Typography>
                        )}
                    </Grid>

                    


                    <Grid item style={{ textAlign: "left", marginTop: 10 }}>
                        {mode === "add" && <Typography style={{ fontSize: "16px", color: "#333" }}>
                            Are you sure you want to link this new asset group with the <br /> following configuration?
                            Please "CANCEL" to make changes.
                        </Typography>
                        }
                        {
                            mode === "edit" && <Typography style={{ fontSize: "16px", color: "#333", marginTop: 10 }}>
                                Are you sure you want to update this linked asset group with the following configuration? Please "CANCEL" to make changes.
                            </Typography>
                        }
                        {mode === "remove" && <Typography style={{ fontSize: "16px", color: "#333", marginTop: 10 }}>
                            Are you sure you want to remove this whole asset group? The assets linked to it will also be removed. This action cannot be undone.
                        </Typography>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container justifyContent="center" spacing={2} style={{ marginTop: 10, marginBottom: 10 }}>
                            <Grid item>
                                <Button onClick={onClose} variant="contained" color="secondary">CANCEL</Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Linking..." : "CONFIRM"}
                                </Button>

                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </DialogContent>
        </Dialog>
    );
};
